import script from "./MobileTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileTabs.vue?vue&type=script&setup=true&lang=ts"

import "./MobileTabs.vue?vue&type=style&index=0&id=25804594&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25804594"]])

export default __exports__